import { render } from "./KioskBucketSize.vue?vue&type=template&id=2260aa22"
import script from "./KioskBucketSize.vue?vue&type=script&lang=js"
export * from "./KioskBucketSize.vue?vue&type=script&lang=js"
script.render = render

export default script